import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed, onMounted, toRef } from 'vue';
import { useStore } from 'vuex';
import LabeledSelect from '@shell/components/form/LabeledSelect.vue';
import { SECRET } from '@shell/config/types';
import { SECRET_TYPES } from '@shell/config/secret';


export default /*@__PURE__*/_defineComponent({
  __name: 'system-default-registry-pull-secrets',
  props: {
    settingValue: {},
    defaultValue: {},
    rules: {}
  },
  emits: ['update:settingValue'],
  setup(__props: any, { emit: __emit }) {

const AUTH_TYPES = [
  SECRET_TYPES.DOCKER_JSON,
  SECRET_TYPES.BASIC,
  SECRET_TYPES.SSH,
  SECRET_TYPES.RKE_AUTH_CONFIG
];

const props = __props;

const emit = __emit;

const store = useStore();
const settingValue = toRef(props, 'settingValue');
const defaultValue = toRef(props, 'defaultValue');
const secrets = ref<any[]>([]);

const secretOptions = computed(() => secrets.value
  .filter((s) => AUTH_TYPES.includes(s._type))
  .map((s) => {
    const { dataPreview, subTypeDisplay, metadata } = s;

    const label = subTypeDisplay && dataPreview ? `${ metadata.name } (${ subTypeDisplay }: ${ dataPreview })` : `${ metadata.name } (${ subTypeDisplay })`;

    return {
      label,
      value: s.metadata?.name
    };
  })
);

const selectedSecrets = computed({
  get: () => {
    const sValue = settingValue.value || defaultValue.value || '';

    return sValue.split(',').reduce((all: string[], secret: string) => {
      if (!!secret.trim()) {
        all.push(secret.trim());
      }

      return all;
    }, []);
  },
  set: (neu: string[]) => {
    const newSettingValue = neu?.length ? neu.join(',') : null;

    emit('update:settingValue', newSettingValue);
  },
});

onMounted(async() => {
  const res = await store.dispatch('management/findAll', {
    type: SECRET,
    opt:  { namespaced: 'cattle-system' },
  });

  secrets.value = Array.isArray(res) ? res : [];
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LabeledSelect, {
    id: "pull-secrets",
    value: selectedSecrets.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((selectedSecrets).value = $event)),
    label: "Image Pull Secrets",
    options: secretOptions.value,
    rules: __props.rules,
    multiple: true
  }, null, 8, ["value", "options", "rules"]))
}
}

})